import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'format' })
export class StringFormatPipe implements PipeTransform {
    public transform(items: string[]): string[] {
        return items.map((value) => {
            const words = value.split(' ');
            words[0] = words[0].toLowerCase();
            return words.join('');
        }
       );
    }

    public transformStr(item: string): string {
        const words = item.split(' ');
        words[0] = words[0].toLowerCase();
        return words.join('');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/stringFormat.pipe.ts